import { useEffect, useState } from 'react';
import Service from '@/app/utils/service';
import API from '@/app/api/internalAPIs';
import { RewardingProposalType, WorkflowConfig } from '../pages/EmploymentForms/types';

const GLOBAL: any = window;
let isHRAdmin = false;
let isManager = false;
let isHR = false;
try {
  isHRAdmin = GLOBAL.top.iHRAdmin;
  isManager = GLOBAL.top.iManager;
  isHR = GLOBAL.top.iHR;
} catch (e) {
  isHRAdmin = false;
  isManager = false;
  isHR = false;
}

export const useWorkflowConfig = () => {
  const [workflowSettings, setWorkflowSettings] = useState<WorkflowConfig[]>([]);

  useEffect(() => {
    Service.get(
      API.workflow.config(),
      (apiResp: WorkflowConfig[]) => {
        setWorkflowSettings(apiResp);
      },
      (err: Error) => {
        console.error(err);
      },
    );
  }, []);

  return (
    workflowSettings.length
      ? workflowSettings.reduce((acc, wfl) => {
          const canAdd =
            (+wfl.fWorkflowMgrCapability[0] >= 1 && isManager) ||
            (+wfl.fWorkflowHrCapability[0] >= 1 && isHR) ||
            isHRAdmin;
          return { ...acc, [wfl.fWorkflowName]: { ...wfl, renderProposal: canAdd } };
        }, {} as Record<RewardingProposalType, boolean>)
      : null
  );
};